import React, { useMemo, useState } from 'react'
import { Box } from '@mui/material'
import MuiFilterSelect from '../../../components/Filters/MuiFilterSelect'
import InlineInfoNote from '../../../components/InlineInfoNote'
import { MobileAdvancedFilterDrawer } from '../../../components/mobile'
import { MOBILE_ADVANCED_FILTER_FIELD_SX } from '../../../components/mobile/styles/mobileAdvancedFilterSx'
import {
  SETTLEMENT_STATUS_FILTER_OPTIONS,
  SETTLEMENT_STATUS_MULTI_DAY_NOTE
} from '../helpers/pendingSettlement'

const DEFAULT_FILTER = { mode: 'all', values: [] }

const cloneFilter = (filter) => ({
  mode: filter?.mode || 'all',
  values: Array.isArray(filter?.values) ? [...filter.values] : []
})

const getAppliedSettlementChip = (filter) => {
  if (!filter || filter.mode === 'all' || !filter.values?.length) return null
  const labels = filter.values
    .map((value) => SETTLEMENT_STATUS_FILTER_OPTIONS.find((item) => item.value === value)?.label)
    .filter(Boolean)
  if (!labels.length) return null
  return { key: 'settlement-status', label: `Estado: ${labels.join(', ')}` }
}

export default function EffectivenessSettlementMobileFilters({
  searchInput,
  onSearchInputChange,
  onSearchSubmit,
  onClearSearch,
  pendingSettlementFilter = DEFAULT_FILTER,
  onPendingSettlementFilterChange,
  isSettlementFilterDisabled = false,
  isSingleDayRange = true
}) {
  const [isOpen, setIsOpen] = useState(false)
  const [draftFilter, setDraftFilter] = useState(() => cloneFilter(pendingSettlementFilter))

  const appliedChip = useMemo(
    () => getAppliedSettlementChip(pendingSettlementFilter),
    [pendingSettlementFilter]
  )
  const appliedFilterChips = appliedChip ? [appliedChip] : []
  const appliedFilterGroupCount = appliedChip ? 1 : 0

  const syncDraftWithApplied = () => {
    setDraftFilter(cloneFilter(pendingSettlementFilter))
  }

  const handleOpen = () => {
    syncDraftWithApplied()
    setIsOpen(true)
  }

  const handleClose = () => {
    syncDraftWithApplied()
    setIsOpen(false)
  }

  const handleClearAll = () => {
    setDraftFilter(cloneFilter(DEFAULT_FILTER))
    onPendingSettlementFilterChange?.(DEFAULT_FILTER)
    setIsOpen(false)
  }

  const handleApply = () => {
    onPendingSettlementFilterChange?.(cloneFilter(draftFilter))
    setIsOpen(false)
  }

  return (
    <MobileAdvancedFilterDrawer
      title="Detalles de reporte"
      drawerTitle="Filtros de reporte"
      query={searchInput}
      onQueryChange={(event) => onSearchInputChange?.(event.target.value)}
      onQueryKeyDown={(event) => {
        if (event.key === 'Enter') onSearchSubmit?.()
      }}
      onClearQuery={onClearSearch}
      searchPlaceholder="Buscar usuario por código o nombre..."
      isOpen={isOpen}
      onOpen={handleOpen}
      onClose={handleClose}
      appliedFilterGroupCount={appliedFilterGroupCount}
      appliedFilterChips={appliedFilterChips}
      onClearAll={handleClearAll}
      onApply={handleApply}
      filterFieldsContent={
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5,
            // Con un solo filtro el sheet queda muy bajo; el dropdown inline
            // es absolute y necesita espacio reservado abajo para verse sin scroll.
            minHeight: 280,
            pb: 1
          }}
        >
          <Box sx={MOBILE_ADVANCED_FILTER_FIELD_SX}>
            <MuiFilterSelect
              title="Estado de liquidación"
              options={SETTLEMENT_STATUS_FILTER_OPTIONS}
              value={draftFilter}
              onChange={(nextValue) => setDraftFilter(cloneFilter(nextValue || DEFAULT_FILTER))}
              searchable={false}
              disabled={isSettlementFilterDisabled}
              width="100%"
              matchTriggerWidth
              inlineDropdown
              autoFocusSearch={false}
            />
          </Box>
          {!isSingleDayRange ? (
            <InlineInfoNote title="" message={SETTLEMENT_STATUS_MULTI_DAY_NOTE} singleLine />
          ) : null}
        </Box>
      }
    />
  )
}
